// Archivo: components/LicensesPage.js
import { motion } from "framer-motion";
import { FaGavel, FaFileAlt, FaCheckCircle } from "react-icons/fa"; // Para los íconos de licencia.

const LicensesPage = () => {
  const licenses = [
    {
      title: "Standard License",
      description:
        "The standard license grants you the right to use the purchased templates for a single project. This includes basic usage for websites and applications without distribution or reselling of the templates.",
      icon: <FaFileAlt className="text-navy-900 text-2xl" />,
    },
    {
      title: "Extended License",
      description:
        "The extended license provides broader usage rights, including the ability to use the templates in multiple projects, as well as allow redistribution and commercial applications, subject to specific terms.",
      icon: <FaGavel className="text-navy-900 text-2xl" />,
    },
    {
      title: "Exclusive License",
      description:
        "The exclusive license grants you the sole ownership of the template, with full usage rights, including the ability to modify, redistribute, and use it for any commercial purpose without restrictions.",
      icon: <FaCheckCircle className="text-navy-900 text-2xl" />,
    },
  ];

  return (
    <div className="licenses-container bg-gradient-to-b from-gray-50 to-gray-100 min-h-screen py-10">
      <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-lg overflow-hidden">
        <header className="bg-navy-900 text-white py-6 px-8">
          <h1 className="text-4xl font-bold text-center">Licenses</h1>
        </header>
        <main className="p-8">
          {licenses.map((license, index) => (
            <motion.section
              key={index}
              className="mb-8 p-6 border border-gray-200 rounded-lg"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
            >
              <div className="flex items-center mb-4">
                {license.icon}
                <h2 className="text-2xl font-semibold text-navy-900 ml-3">{license.title}</h2>
              </div>
              <p className="text-gray-700 leading-relaxed">{license.description}</p>
            </motion.section>
          ))}
        </main>
        <footer className="bg-gray-50 border-t border-gray-200 py-4 px-8">
          <p className="text-center text-sm text-gray-600">
            © {new Date().getFullYear()} PixelCraft by Nine Star United,SRL. All rights reserved.
          </p>
        </footer>
      </div>
    </div>
  );
};

export default LicensesPage;
